import React from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './SynergyItem.module.scss';

const SynergyItem = props => (
  <div className={styles.ItemContainer}>
    <div className={styles.IconContainer}>
      <img
        src={OptimizeImagesService.adjustImageSize(props.specialization.logo)}
        alt="icon"
        className={styles.Icon}
      />
    </div>
    <p className={styles.Text}>{props.specialization.header}</p>
  </div>
);

SynergyItem.propTypes = {
  specialization: PropTypes.object.isRequired
};

export default SynergyItem;



// WEBPACK FOOTER //
// ./src/views/Synergy/components/SynergyItem/SynergyItem.js